import { render } from "./Eleganza.vue?vue&type=template&id=5528277f&scoped=true"
import script from "./Eleganza.vue?vue&type=script&lang=js"
export * from "./Eleganza.vue?vue&type=script&lang=js"

import "./Eleganza.vue?vue&type=style&index=0&id=5528277f&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5528277f"

export default script